import { styled } from '@linaria/react';
import {
  fonts,
  layout,
  primitives,
  radius,
  semantic,
  shadow,
  space,
  textStyle,
} from '../../theme/tokens';
import { EntityImage } from '../../components/EntityImage';

export const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: ${space['space-300']} 0 ${space['space-600']};
`;

export const CloseButton = styled.button`
  position: absolute;
  top: ${space['space-400']};
  right: ${space['space-300']};
  width: 44px;
  height: 32px;
  border-radius: ${radius('button', 'radius-full')};
  background: ${semantic.bg.canvas};
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${semantic.text.primary};
  z-index: 1;
  box-shadow: ${shadow.sm};
`;

export const Image = styled(EntityImage)`
  display: block;
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: ${radius('image', 'radius-md')};

  @media (max-width: ${layout.desktopBreakpoint}) {
    height: 170px;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${space['space-500']};
  padding: ${space['space-800']} 0 ${space['space-600']};
  text-align: center;
`;

export const Heading = styled.h2`
  margin: 0;
  font-family: ${textStyle.display['size-md'].fontFamily};
  font-size: ${textStyle.display['size-md'].fontSize};
  font-weight: ${textStyle.display['size-md'].fontWeight};
  line-height: ${textStyle.display['size-md'].lineHeight};
  letter-spacing: ${textStyle.display['size-md'].letterSpacing};
  color: ${semantic.text.primary};
`;

export const ValidFor = styled.p`
  margin: 0;
  font-family: ${fonts.body};
  font-size: ${fonts.size.base};
  font-weight: ${fonts.weight.normal};
  line-height: ${primitives.typography.lineHeight.normal};
  letter-spacing: ${primitives.typography.tracking.normal};
  color: ${semantic.text.primary};
`;

export const Body = styled.div`
  font-family: ${fonts.body};
  font-size: ${fonts.size.base};
  color: ${semantic.text.secondary};
  line-height: ${primitives.typography.lineHeight.normal};

  & p {
    margin: 0 0 ${space['space-200']};
    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const CtaContainer = styled.div`
  margin-top: ${space['space-200']};
`;
